import { useState } from 'react'

export default function ContactForm() {
  const [status, setStatus] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    if (!e || typeof e.preventDefault !== 'function') return
    e.preventDefault()
    setLoading(true)
    setStatus('')

    const formData = new FormData(e.target)
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      subject: formData.get('service') || 'AI Service Inquiry',
      service: formData.get('service'),
      message: formData.get('message')
    }

    try {
      const res = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      const result = await res.json()
      if (res.ok) {
        setStatus('success')
        e.target.reset()
      } else {
        setStatus('error: ' + (result.error || 'Failed'))
      }
    } catch (err) {
      setStatus('error: Unable to connect')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input type="text" id="name" name="name" placeholder="Rajesh" required />
          <i className="fas fa-user input-icon"></i>
        </div>
        <div className="form-group">
          <label htmlFor="email">Work Email</label>
          <input type="email" id="email" name="email" placeholder="rajesh@gmail.com" required />
          <i className="fas fa-envelope input-icon"></i>
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="service">Service Interested In</label>
        <select id="service" name="service" required>
          <option value="" disabled selected>Select a service...</option>
          <option value="AI Chatbot / Ask Us Widget">AI Chatbot / Ask Us Widget</option>
          <option value="AI Product/Service Recommender">AI Product/Service Recommender</option>
          <option value="Smart Search">Smart Search</option>
          <option value="AI powered quote/estimate generator">AI powered quote/estimate generator</option>
          <option value="Voice Assistant">Voice Assistant</option>
          <option value="Multilingual Auto-Translation">Multilingual Auto-Translation</option>
          <option value="AI Review Summarizer">AI Review Summarizer</option>
          <option value="AI Lead Qualifier">AI Lead Qualifier</option>
          <option value="Appointment Booking Assistant">Appointment Booking Assistant</option>
          <option value="Abandoned Cart / Exit-Intent AI Popup">Abandoned Cart / Exit-Intent AI Popup</option>
          <option value="AI-Written Personalized Follow-Up Emails">AI-Written Personalized Follow-Up Emails</option>
          <option value="Auto-Generated Blog/SEO Content">Auto-Generated Blog/SEO Content</option>
          <option value="AI Meta-Description / SEO Tag Generator">AI Meta-Description / SEO Tag Generator</option>
          <option value="Auto-Summarize Long Pages / PDFs / Docs">Auto-Summarize Long Pages / PDFs / Docs</option>
          <option value="AI powered image alt-text & accessibility">AI powered image alt-text & accessibility</option>
          <option value="Full AI Stack">Full AI Stack</option>
          <option value="Other">Other</option>
        </select>
        <i className="fas fa-cube input-icon"></i>
      </div>
      <div className="form-group">
        <label htmlFor="message">Tell us about your website and needs</label>
        <textarea id="message" name="message" rows="5" placeholder="Describe your business, current website, and what AI features would help..." required></textarea>
      </div>
      <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={loading}>
        {loading ? 'Sending...' : 'Send'} <i className="fas fa-paper-plane"></i>
      </button>
      {status && (
        <div className={`form-status ${status.startsWith('success') ? 'success' : 'error'}`}>
          {status.startsWith('success') 
            ? 'Thank you! We\'ll analyze your website and get back to you within 24 hours with a free AI audit.' 
            : status.replace(/^(success|error):\s*/, '')}
        </div>
      )}
    </form>
  )
}
